import { render, staticRenderFns } from "./ContentImport.vue?vue&type=template&id=0328d7f4&"
import script from "./ContentImport.vue?vue&type=script&lang=js&"
export * from "./ContentImport.vue?vue&type=script&lang=js&"
import style0 from "./ContentImport.vue?vue&type=style&index=0&id=0328d7f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports